import { MutationTree } from 'vuex';
import { AuthState } from './types';
import { initialState } from './state';
import axios from 'axios';
import { Credentials } from '@/shared/model/smallPayloadModels/credentials';

import LSService from '../../../backend/LocalStorageService';

const lsService = LSService.getService();

export const mutations: MutationTree<AuthState> = {
  /**
   * Set the authentication token.
   */
  ['token']: (state: AuthState, token: string) => {
    state.token = token;
    if (token) {
      localStorage.setItem('accessToken', token);
      axios.defaults.headers.common.Authorization = token;
    } else {
      localStorage.removeItem('accessToken');
      delete axios.defaults.headers.common.Authorization;
    }
  },

  setAzureData(state: AuthState, payload: any) {
    if (Array.isArray(payload)) {
      state.azureData = payload[0];
    } else {
      state.azureData = payload;
    }
  },
  setIsUserInAzureAdminGroup(state, payload: any) {
    state.isUserInAzureAdminGroup = payload;
  },
  setUserAdminGroups(state, payload: any) {
    state.userAdminGroups = payload;
  },

  setAccountId(state: AuthState, id: string) {
    state.error = false;
    state.accountId = id;
  },
  setArticlesTotal(state, payload: number) {
    state.articles.total = payload;
  },
  setArticlesIsLoading(state, payload: boolean) {
    state.articles.isLoading = payload;
  },
  setEnvironment(state, payload: string) {
    state.environment = payload;
  },

  setAccount(state: AuthState, payload: Credentials | undefined) {
    state.error = false;
    state.account = payload;
  },
  setToken(state: AuthState, payload: any) {
    lsService.setToken(payload);
  },
  clearTokens(state: AuthState, payload: any) {
    lsService.clearToken();
  },
  reset(state) {
    const s = initialState();
    Object.keys(s).forEach((key: string) => {
      state[key] = s[key];
    });
  },
  setLoadSupportContactList(state, payload: boolean) {
    state.isLoadSupportContactList = payload;
  },
  setInitialRedirect(state, payload: any) {
    state.isInitialRedirect = payload;
  },
};
